import { Texture } from "pixi.js";
import { CommonResourcesPackage } from "../../../resources/CommonResourcesPackage";

export class CoinsTexturePack {
    public readonly randomCoins: Texture[];
    public readonly rotationCoins: Texture[];
    
    public constructor(commonResources: CommonResourcesPackage) {
        this.randomCoins = this.randomCoinsTextures(commonResources);
        this.rotationCoins = this.rotateCoinsTextures(commonResources);
    }

    private randomCoinsTextures(commonResources: CommonResourcesPackage): Texture[] {
        return [
            commonResources.assets_common_ui_coins_random_coins_1_png,
            commonResources.assets_common_ui_coins_random_coins_2_png,
            commonResources.assets_common_ui_coins_random_coins_3_png,
            commonResources.assets_common_ui_coins_random_coins_4_png,
            commonResources.assets_common_ui_coins_random_coins_5_png,
            commonResources.assets_common_ui_coins_random_coins_6_png,
            commonResources.assets_common_ui_coins_random_coins_7_png,
            commonResources.assets_common_ui_coins_random_coins_8_png,
            commonResources.assets_common_ui_coins_random_coins_9_png,
            commonResources.assets_common_ui_coins_random_coins_10_png,
            commonResources.assets_common_ui_coins_random_coins_11_png,
            commonResources.assets_common_ui_coins_random_coins_12_png,
            commonResources.assets_common_ui_coins_random_coins_13_png,
            commonResources.assets_common_ui_coins_random_coins_14_png,
            commonResources.assets_common_ui_coins_random_coins_15_png,
            commonResources.assets_common_ui_coins_random_coins_16_png
        ];
    }

    private rotateCoinsTextures(commonResources: CommonResourcesPackage): Texture[] {
        return [
            commonResources.assets_common_ui_coins_rotate_animation_0000_png,
            commonResources.assets_common_ui_coins_rotate_animation_0001_png,
            commonResources.assets_common_ui_coins_rotate_animation_0002_png,
            commonResources.assets_common_ui_coins_rotate_animation_0003_png,
            commonResources.assets_common_ui_coins_rotate_animation_0004_png,
            commonResources.assets_common_ui_coins_rotate_animation_0005_png,
            commonResources.assets_common_ui_coins_rotate_animation_0006_png,
            commonResources.assets_common_ui_coins_rotate_animation_0007_png,
            commonResources.assets_common_ui_coins_rotate_animation_0008_png,
            commonResources.assets_common_ui_coins_rotate_animation_0009_png,
            commonResources.assets_common_ui_coins_rotate_animation_0010_png,
            commonResources.assets_common_ui_coins_rotate_animation_0011_png,
            commonResources.assets_common_ui_coins_rotate_animation_0012_png,
            commonResources.assets_common_ui_coins_rotate_animation_0013_png,
            commonResources.assets_common_ui_coins_rotate_animation_0014_png,
            commonResources.assets_common_ui_coins_rotate_animation_0015_png
        ];
    }
}